module.exports = __webpack_public_path__ + "static/media/paypal-logo.42aaffcf.svg";